import { G2S } from '../g2s';
import * as api from '../api';

export class PromotionService {
    createMember(request: api.PromotionMemberCreateRequest): Promise<api.PromotionMemberCreateResult> {
        return new Promise<api.PromotionMemberCreateResult>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Promotion/Member/Create',
                    request,
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.PromotionMemberCreateResult>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }
}
